import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";

import { getAllProducts, getSegnents_Fields } from "../../api/Products";
import LoadingSpinner from "../../components/LoadingSpinner";
import HeroSectionPrime from "../../components/HeroSectionPrime";
import HeroProductsFilter from "./sections/HeroProductsFilter";

import CategorySection from "./sections/CategorySection";
import { useProducts } from "./productsProvider";


const NoDataParam = () => (
  <div className="h-96 flex flex-col items-center justify-center">
    <h1>
      <i className="fa-solid fa-face-dizzy"></i>
    </h1>
    <br />
    <h3>no data have been found</h3>
  </div>
);

const Products = () => {
  // const [products, setProducts] = useState([]);
  const [segmentField, setSegmentField] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [FilterParameters, setFilterParameters] = useSearchParams();
  const [page, setPage] = useState(1);
  // const [loading, setLoading] = useState(false);
  const [moreloading, setMoreLoading] = useState(false);

  const { products, loading } = useProducts();



  const [hasMore, setHasMore] = useState(true);
  // const [pageLoading, setPageLoading] = useState(false);

  const searchQuery = searchParams.get("search") || "";

  const filters = {
    segments: FilterParameters.get("segments"),
    fields: FilterParameters.get("fields"),
  };

  const handleSearch = (query) => {
    setSearchParams({ search: query });
  };

  // const fetchProducts = async (page) => {
  //   setMoreLoading(true);
  //   const data = await getAllProducts(9, page, searchQuery, filters);
  //   if (data.length === 0) {
  //     setHasMore(false);
  //   } else {
  //     setProducts((prevProducts) => [...prevProducts, ...data]);
  //   }
  //   setMoreLoading(false);
  // };

  // useEffect(() => {
  //   const initialFetch = async () => {
  //     setLoading(true);
  //     setProducts([]);
  //     setPage(1);
  //     setHasMore(true);
  //     const data = await getAllProducts(6, 1, searchQuery, filters);
  //     if (data.length === 0) {
  //       setHasMore(false);
  //     }
  //     console.log(data);
  //     //console.log(data)
  //     setProducts(data);
  //     setLoading(false);
  //   };

  //   initialFetch();
  // }, [searchQuery, filters.segments, filters.fields]);

  // useEffect(() => {
  //   const initialFetch = async () => {
  //     setLoading(true);
  //     setProducts([]);
  //     setPage(1);
  //     setHasMore(true);
  //     const data = await getAllProducts();
  //     if (data.length === 0) {
  //       setHasMore(false);
  //     }
  //     console.log(data);
  //     localStorage.setItem("products",data)
  //     //console.log(data)
  //     setProducts(data);
  //     setLoading(false);
  //   };

  //   initialFetch();
  // }, []);

  // useEffect(() => {
  //   if (page > 1) {
  //     fetchProducts(page);
  //   }
  // }, [page]);

  useEffect(() => {
    const fetchSegmentField = async () => {
      const data = await getSegnents_Fields();
      setSegmentField({ ...data });
    };

    fetchSegmentField();
  }, []);

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
  };


  const categories = [
     {
    name: "Ultrasound Cardiovascular",
    value: "Cardiovascular",
    image: require("../../assets/Products/Cardiovascular.png"),
  },
  {
    name: "Ultrasound General Imaging",
    value: "General Imaging",
    image: require("../../assets/Products/GeneralImaging.png"),
  },
  {
    name: "Ultrasound Obstetrics and Gynecology",
    value: "Obstetrics and Gynecology",
    image: require("../../assets/Products/ObstetricsAndGynecology.png"),
  },
 
  {
    name: "Ultrasound Point of Care",
    value: "Point of Care",
    image: require("../../assets/Products/PointOfCare.png"),
  },
];

  const get_Field_Application = new Set(
    products.flatMap((p) => p.clinicalSegments.fieldOfApplication)
  );

  return (
    <div className="App-header bg-[#EAEEF0] ">
      <img src={require("../../assets/Products/mainSect.png")} alt="Main Section" />

<br/>
      <div className="w-full md:w-[85%] m-auto px-3 text-center md:p-5 md:px-32 ">

        <h3 className="font-bold text-4xl md:text-5xl">Because every image counts</h3>
        <br/>
        <p className="md:text-xl">Philips ultrasound solutions connect technology, clinicians and patients to empower patient-focused care and elevate the healthcare experience. Our comprehensive portfolio – ranging from ultra-mobile handheld devices to premium cart-based systems – is designed to empower clinical confidence, with innovations that enhance imaging accuracy and performance. We’re committed to designing sustainable solutions for reliability, scalability and ease-of-use. Paired with shared architecture and comprehensive service programs, our solutions deliver lifetime value to you and your patients.</p>

      </div>

      <br/><br/>
      <div className="mt-5 w-full">
        <HeroProductsFilter
          categoriesField={categories}
        />

        {loading ? (
          <div className="flex items-center justify-center h-screen">
            <LoadingSpinner />
          </div>
        ) : (
          // route /
          <CategorySection
            get_Field_Application={get_Field_Application}
            products={products}
          />
        )}
      </div>
    </div>
  );
};


export default Products;
